<template>
  <a-locale-provider :locale="locale">
    <div id="app">
      <router-view/>
    </div>
  </a-locale-provider>

</template>
<script>
    import Vue from 'vue'
    import {LocaleProvider} from 'ant-design-vue'
    import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
    import { mapActions } from 'vuex'

    Vue.use(LocaleProvider)
    export default {
        data() {
            return {
                locale: zhCN,
            }
        },
        created() {
          this.getSecurityConfig()
        },
        methods: {
          ...mapActions(['getSecurityConfig']),
        }
    }
</script>
<style lang="scss">
#app {
  min-height: 100vh;
  background-color: #f6f8fb;
}
a:focus {
    text-decoration: none;
}
.ant-form .anticon-check-circle{
  display:none;
}
.w-content {
  width: 1280px;
  margin: 0 auto;
}
</style>
